import storage from 'redux-persist/lib/storage';

export default storage;
